import _ from 'lodash';
import { combineReducers } from 'redux';

import types from 'frontend/state/actionTypes';

const clearFields = [
  'armoryRegion',
  'armoryRealm',
  'armoryName',
  'talentsOverride',
  'talentsModalOpen',
  'text',
];

const errorReducer = (state = null, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_CHAR_FAILURE:
      return payload;
    case types.FETCH_CHAR_REQUEST:
    case types.FETCH_CHAR_SUCCESS:
    case types.FETCH_CHAR_CANCELLED:
    case types.FETCH_SIMC_ITEMS_REQUEST:
    case types.FETCH_SIMC_ITEMS_SUCCESS:
      return null;
    case types.INPUT_FORM:
      if (_.includes(clearFields, payload.field)) {
        return null;
      }
      return state;
    default:
      return state;
  }
};

const dataReducer = (state = null, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_CHAR_SUCCESS:
      return payload;
    case types.FETCH_CHAR_REQUEST:
    case types.FETCH_CHAR_FAILURE:
    case types.FETCH_CHAR_CANCELLED:
    case types.FETCH_SIMC_ITEMS_REQUEST:
    case types.FETCH_SIMC_ITEMS_SUCCESS:
      return null;
    case types.INPUT_FORM:
      if (_.includes(clearFields, payload.field)) {
        return null;
      }
      return state;
    default:
      return state;
  }
};

const talentsReducer = (state = null, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.INPUT_FORM:
      return null;
    case types.FETCH_CHAR_SUCCESS: {
      // only reset if the character has changed
      if (payload.changed) {
        return null;
      }
      return state;
    }
    case types.CHOOSE_TALENTS_OVERRIDE:
      return payload;
    default:
      return state;
  }
};

const talentsModalOpenReducer = (state = false, action = {}) => {
  const { type } = action;
  switch (type) {
    case types.CHOOSE_TALENTS_OVERRIDE:
      return false;
    case types.TOGGLE_TALENTS_OVERRIDE_OVERLAY:
      return !state;
    default:
      return state;
  }
};

const whenReducer = (state = null, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_CHAR_SUCCESS:
      return new Date().getTime();
    case types.FETCH_CHAR_REQUEST:
    case types.FETCH_CHAR_FAILURE:
      return null;
    case types.INPUT_FORM:
      if (_.includes(clearFields, payload.field)) {
        return null;
      }
      return state;
    default:
      return state;
  }
};

const loadingReducer = (state = false, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_CHAR_REQUEST:
      return true;
    case types.FETCH_CHAR_SUCCESS:
    case types.FETCH_CHAR_FAILURE:
    case types.FETCH_CHAR_CANCELLED:
      return false;
    case types.INPUT_FORM:
      if (payload.field === 'armoryName' && payload.value) {
        return true;
      } if (_.includes(clearFields, payload.field)) {
        return false;
      }
      return state;
    default:
      return state;
  }
};

export default combineReducers({
  error: errorReducer,
  data: dataReducer,
  talents: talentsReducer,
  talentsModalOpen: talentsModalOpenReducer,
  loading: loadingReducer,
  when: whenReducer,
});

export const selectors = {
  data: state => state.simbot.character.data,
  talents: state => state.simbot.character.talents,
  talentsModalOpen: state => state.simbot.character.talentsModalOpen,
  loading: state => state.simbot.character.loading,
  error: state => state.simbot.character.error,
  when: state => state.simbot.character.when,
};
